import { configureStore } from "@reduxjs/toolkit";
import enquiryReducer from "../features/enquiry/enquirySlice";
import bookingReducer from "../features/booking/bookingSlice";
import uploadReducer from "../features/upload/uploadSlice";
import authReducer from "../features/auth/authSlice";
import trackReducer from "../features/track/trackSlice"
import projectReducer from "../features/project/projectSlice"

export const store = configureStore({
  reducer: {
    auth: authReducer,
  
     enquiry: enquiryReducer,
    booking:bookingReducer,
    upload: uploadReducer,
    track: trackReducer,
    project: projectReducer,
  },
});
